(function(){
    'use strict'

    angular
    .module('app.grupos')
    .controller('Grupos', Grupos);

    Grupos.$inject = ['$animationsSrv', 'GruposService', 'logger', '$location', 'UserInfoService'];

    function Grupos($animationsSrv, GruposService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        var PERMISO_ID = 3;

        vm.grupos = [];
        vm.title = 'Grupos';
        vm.permisos = UserInfoService.getPermisos(PERMISO_ID);

        vm.goToEdit = function(grupo){
            
            var path = '/editar-grupo/';

            if(grupo){
                $location.path(path + grupo.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.goToPermisos = function(grupo){
            
            var path = '/permisos/';

            $location.path(path + grupo.id);
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = GruposService.getAll(UserInfoService.getCliente());

            promise
            .then(function(grupos){
                vm.grupos = grupos;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los grupos.');
                        break;
                }
            });
        };

        vm.delete = function(grupo){
            var promise = GruposService.remove(grupo);
            
            promise
            .then(function(response){
                vm.grupos = vm.grupos.filter(function(g) {
                    return g.id !== grupo.id;
                });
                logger.success('Grupo eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el grupo');
                        break;
                }
                
            });   
        };

    }
})();